import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Login {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  data?: any;
}
let initialState: Login = {
  isLoading: false,
  error: false,
  message: null,
};
const LoginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    loginWithEmail: (state: Login, action: PayloadAction<{}>) => {
      state.isLoading = true;
    },
    setData: (state: any, action: PayloadAction<Login>) => {
      return action.payload;
    },
    clearData: (state: Login, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loginWithEmail, setData, clearData } = LoginSlice.actions;

export default LoginSlice.reducer;
